import { createFileRoute } from '@tanstack/react-router'
import AdminDashboard from '../pages/(Admin)/Dashboard/AdminDashboard'
import AppLayout from '../layouts/AppLayout'

export const Route = createFileRoute('/dashboard')({
  component: DashboardComponent,
})

function DashboardComponent() {
  return (
    <AppLayout>
      <AdminDashboard />
    </AppLayout>
  )
}
